var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1f1f28;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.177,25.613a13.868,13.868,0,0,0-2.184-.571A16.906,16.906,0,0,0,12,24.779a17.96,17.96,0,0,0-2.976.248,14.533,14.533,0,0,0-2.167.529A10.565,10.565,0,0,0,0,31.779s2.133,7,12,7c9.547,0,12-7,12-7A11.242,11.242,0,0,0,17.177,25.613ZM12,26.079a14.649,14.649,0,0,1,4.257.594,4.655,4.655,0,0,1,.443,1.962,4.7,4.7,0,0,1-9.4,0,4.646,4.646,0,0,1,.464-2A15.381,15.381,0,0,1,12,26.079Zm0,11.4c-7.531,0-10.021-4.359-10.608-5.7A9.232,9.232,0,0,1,6.18,27.2a6,6,0,1,0,11.659.074,9.928,9.928,0,0,1,4.746,4.506C21.9,33.19,19.212,37.479,12,37.479Z",
    transform: "translate(0 -24.779)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye-open.d1f54608.svg";
export { ForwardRef as ReactComponent };